import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined';

export const MOBILE_DASHBOARD_PANEL_STORAGE_KEY = 'roomnexa-mobile-dashboard-panel';

/** Mobile dashboard panels — labels match desktop booking calendar toggles. */
export const MOBILE_DASHBOARD_MODES = [
  {
    id: 'overview',
    label: 'Overview',
    shortLabel: 'Home',
    icon: SpaceDashboardOutlinedIcon,
    displayView: null,
  },
  {
    id: 'grid',
    label: 'Grid',
    shortLabel: 'Grid',
    icon: GridViewOutlinedIcon,
    displayView: 'ultra',
  },
  {
    id: 'ultra',
    label: 'Ultra',
    shortLabel: 'Ultra',
    icon: ViewWeekOutlinedIcon,
    displayView: 'calendar',
  },
  {
    id: 'calendar',
    label: 'Calendar',
    shortLabel: 'Cal',
    icon: CalendarMonthOutlinedIcon,
    displayView: 'month',
  },
];

export function readStoredMobileDashboardPanel() {
  try {
    const stored = sessionStorage.getItem(MOBILE_DASHBOARD_PANEL_STORAGE_KEY);
    if (MOBILE_DASHBOARD_MODES.some((mode) => mode.id === stored)) {
      return stored;
    }
  } catch {
    // ignore
  }
  return 'overview';
}

export function writeStoredMobileDashboardPanel(panelId) {
  try {
    sessionStorage.setItem(MOBILE_DASHBOARD_PANEL_STORAGE_KEY, panelId);
  } catch {
    // ignore
  }
}

export function mobilePanelToDisplayView(panelId) {
  return MOBILE_DASHBOARD_MODES.find((mode) => mode.id === panelId)?.displayView || 'ultra';
}

export function displayViewToMobilePanel(displayView) {
  const match = MOBILE_DASHBOARD_MODES.find((mode) => mode.displayView === displayView);
  return match?.id || 'grid';
}
